import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { Link } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';

import AddIcon from 'material-ui/svg-icons/content/add';

import * as accountGroupsActions from '../../actions/entities/AccountGroupsActions';
import { Grid, GridHeader, GridBody, GridRow, GridCell } from '../../components/basic/grid';
import FloatingActionButton from '../../components/basic/FloatingActionButton';
import { LANGUAGES } from '../../constants/Constants';

class AccountGroupsContainer extends React.Component {
  componentDidMount() {
    this.props.fetchAccountGroups();
  }

  render() {
    const { accountGroups } = this.props;
    return (
      <div className="flex flex1">
        <Grid>
          <GridHeader>
            <GridRow className="row">
              <GridCell className="col-sm-3">
                <span>Name</span>
              </GridCell>
              <GridCell className="col-sm-3">
                <span>Default for language</span>
              </GridCell>
              <GridCell className="col-sm-3">
                <span># Companies</span>
              </GridCell>
              <GridCell className="col-sm-3">
                <span># Admins</span>
              </GridCell>
            </GridRow>
          </GridHeader>
          <ScrollArea smoothScrolling>
            <GridBody>
              {R.map(
                g => (
                  <Link key={g.id} to={`/settings/accounts/groups/${g.id}`}>
                    <GridRow className="row">
                      <GridCell className="col-sm-3">
                        <span>{g.name}</span>
                      </GridCell>
                      <GridCell className="col-sm-3">
                        <span>
                          {g.defaultForLanguage &&
                            (R.find(l => l.value === g.defaultForLanguage, LANGUAGES) || {}).label}
                        </span>
                      </GridCell>
                      <GridCell className="col-sm-3">
                        <span>{g.companies.length}</span>
                      </GridCell>
                      <GridCell className="col-sm-3">
                        <span>{g.admins.length}</span>
                      </GridCell>
                    </GridRow>
                  </Link>
                ),
                accountGroups
              )}
            </GridBody>
          </ScrollArea>
        </Grid>
        <FloatingActionButton
          className="fixed bottom-right-element"
          containerElement={<Link to="/settings/accounts/groups/new" />}
        >
          <AddIcon />
        </FloatingActionButton>
      </div>
    );
  }
}

export default connect(state => ({ accountGroups: state.entities.accountGroups.items }), accountGroupsActions)(
  AccountGroupsContainer
);



// WEBPACK FOOTER //
// ./src/containers/private/AccountGroupsContainer.js